import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TranscriptCourseAttendanceStatusService from "../../src/Domain/TranscriptCourseAttendanceStatus/TranscriptCourseAttendanceStatus.service";
const TranscriptCourseAttendanceStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            // @ts-expect-error - TS2345 - Argument of type 'number[]' is not assignable to parameter of type 'string[]'.
            return TranscriptCourseAttendanceStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TranscriptCourseAttendanceStatusService.getTranscriptCourseAttendanceStatuses(search);
        },
        optionRenderer: function optionRenderer(transcriptCourseAttendanceStatus) {
            return _jsx("span", { children: transcriptCourseAttendanceStatus.name });
        },
    });
};
export default TranscriptCourseAttendanceStatusLookup;
